import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ErrorLogPageComponent} from './containers/error-log';
import {ErrorLogListComponent} from './components/error-log-list';
import {AdminDashboardPageComponent} from './containers/admin-dashboard';
import {SettingSectionComponent} from './containers/setting';
import {AdminSettingsPageComponent} from './containers/admin-settings';
import {SettingEditorPageComponent} from './containers/setting-editor';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SettingListComponent} from './components/setting-list';
import {SettingEditorFormComponent} from './components/setting-editor-form';
import {DashboardPageComponent} from './containers/dashboard';
import {AdminAccessRequestsPageComponent} from './containers/admin-access-requests';
import {RegisterPageComponent} from './containers/register';
import {AdminUsersPageComponent} from './containers/admin-users';
import {UserEditorPageComponent} from './containers/user-editor';
import {UserSectionComponent} from './containers/user';
import {ContactSectionComponent} from './containers/contact';
import {ContactEditorPageComponent} from './containers/contact-editor';
import {AdminContactsPageComponent} from './containers/admin-contacts';
import {AdminListsPageComponent} from './containers/admin-lists';
import {ListComponent} from './containers/list';
import {ListItemEditorPageComponent} from './containers/list-item-editor';
import {LoginPageComponent} from './containers/login';
import {ForgotPasswordPageComponent} from './containers/forgot-password';
import {ChangePasswordPageComponent} from './containers/change-password';
import {PagingHeaderComponent} from './components/paging-header';
import {PagingFooterComponent} from './components/paging-footer';
import {LoggedInGuard} from './guards/logged-in';
import {ChangePasswordGuard} from './guards/change-password';
import {AdminGuard} from './guards/admin';
import {SuperAdminGuard} from './guards/super-admin';
import {ListItemListComponent} from './components/list-item-list';
import {ListItemEditorFormComponent} from './components/list-item-editor-form';
import {ContactListComponent} from './components/contact-list';
import {ContactFormComponent} from './components/contact-form';
import {RegisterFormComponent} from './components/register-form';
import {RegisteredMessageComponent} from './components/registered-message';
import {AccessRequestListComponent} from './components/access-request-list';
import {AccessRequestControlsComponent} from './components/access-request-controls';
import {UserListComponent} from './components/user-list';
import {UserEditorFormComponent} from './components/user-editor-form';
import {UserEditorHeaderComponent} from './components/user-editor-header';
import {AdminSectionComponent} from './containers/admin.component';
import {UserGuard} from './guards/user';
import {AdminSubmenuComponent} from './components/admin-submenu';
import {EffectsModule} from '@ngrx/effects';
import {LogEffects} from './effects/log';
import {SettingEffects} from './effects/setting';
import {ListEffects} from './effects/list';
import {ContactEffects} from './effects/contact';
import {RegisterEffects} from './effects/register';
import {UserEffects} from './effects/user';
import {AuthenticationEffects} from './effects/authentication';
import {AuthenticationService} from './services/authentication';
import {TokenHttp} from './services/token-http';
import {ErrorLogService} from './services/error-log';
import {ListManagementService} from './services/list';
import {SettingService} from './services/setting';
import {UserService} from './services/user';
import {RegistrationService} from './services/registration';
import {ContactService} from './services/contact';
import {ErrorMessageComponent} from './components/error-message';
import {StoplightIndicatorComponent} from './components/stoplight-indicator';
import {UtcDatePipe} from './pipes/utc';
import {AdminButtonsComponent} from './components/admin-buttons';
import {EllipsisPipe} from './pipes/ellipsis';
import { StoreModule } from '@ngrx/store';
import {reducers} from './reducers';
import { RouterEffects } from 'app/modules/core/effects/router';
import { UserAgreementService } from 'app/modules/core/services/user-agreement';
import { UserAgreementGuard } from 'app/modules/core/guards/user-agreement';
import { UserAgreementContainerComponent } from 'app/modules/core/containers/user-agreement';
import { TOKENS_PROVIDERS } from 'app/modules/core/tokens/countries';
import { CountryService } from 'app/modules/core/services/country';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    EffectsModule.forFeature([LogEffects,
      SettingEffects,
      ListEffects,
      ContactEffects,
      RegisterEffects,
      UserEffects,
      AuthenticationEffects,
      RouterEffects]),
      StoreModule.forFeature('core', reducers)
  ],
  declarations: [
    ErrorLogPageComponent,
    ErrorLogListComponent,
    AdminDashboardPageComponent,
    SettingSectionComponent,
    AdminSettingsPageComponent,
    SettingEditorPageComponent,
    SettingListComponent,
    SettingEditorFormComponent,
    DashboardPageComponent,
    AdminAccessRequestsPageComponent,
    RegisterPageComponent,
    AdminUsersPageComponent,
    UserEditorPageComponent,
    UserSectionComponent,
    ContactSectionComponent,
    ContactEditorPageComponent,
    AdminContactsPageComponent,
    AdminListsPageComponent,
    ListComponent,
    ListItemEditorPageComponent,
    LoginPageComponent,
    ForgotPasswordPageComponent,
    ChangePasswordPageComponent,
    PagingHeaderComponent,
    PagingFooterComponent,
    ListItemListComponent,
    ListItemEditorFormComponent,
    ContactListComponent,
    ContactFormComponent,
    RegisterFormComponent,
    RegisteredMessageComponent,
    AccessRequestListComponent,
    AccessRequestControlsComponent,
    UserListComponent,
    UserEditorFormComponent,
    UserEditorHeaderComponent,
    AdminSectionComponent,
    AdminSubmenuComponent,
    ErrorMessageComponent,
    StoplightIndicatorComponent,
    UtcDatePipe,
    AdminButtonsComponent,
    EllipsisPipe,
    UserAgreementContainerComponent
  ],
  exports: [PagingHeaderComponent,
    PagingFooterComponent,
    ErrorMessageComponent,
    StoplightIndicatorComponent,
    UtcDatePipe,
    EllipsisPipe
  ],
  providers: [
    LoggedInGuard,
    ChangePasswordGuard,
    AdminGuard,
    SuperAdminGuard,
    UserGuard,
    AuthenticationService,
    TokenHttp,
    ErrorLogService,
    ListManagementService,
    SettingService,
    UserService,
    RegistrationService,
    ContactService,
    UserAgreementService,
    UserAgreementGuard,
    TOKENS_PROVIDERS,
    CountryService
  ]
})
export class DandPCoreModule { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/dandp-core.module.ts